import axios from "../services/axios";



export async function getLastOrderedProducts ({companyId, clientId}) {
    try {

        const res = await axios.get(`/smartmenu/client/orders/last-products`, {
            params: {
                company_id: companyId,
                client_id: clientId
            }
        })

        if (res.status == 200) {
            return res.data;
        }

    } catch (error) {
        console.error('ERROR - GET CLIENT LAST PRODUCTS FUNCTION:', error);
    }
}